<div class="home-container" *ngIf="!isLoading" [ngClass]="{ 'single-column': !hasNewsData }">
  <ng-container *ngIf="homePageData || hasNewsData; else noDataHomePage">
    <div class="main-container" *ngIf="homePageData; else noDataHomePage">
      <div class="analysis-overview-container">
        <div i18n class="container-title">Analysis Overview</div>
        <ng-container i18n *ngIf="analysisData.length > 0; else noData">
          <div class="list-container">
            <div class="item-container" *ngFor="let item of analysisData">
              <app-analysis-list-item [analysis]="item" [url]="'/analysis'"></app-analysis-list-item>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="instrument-sample-container">
        <div class="sample-container">
          <div i18n class="container-title">Recently Created Samples</div>
          <ng-container i18n *ngIf="sampleData.length > 0; else noData">
            <div class="list-container">
              <div class="secondary-item-container" *ngFor="let sample of sampleData">
                <app-secondary-list-item [item]="sample" [config]="sampleConfig" [url]="'/sample-test'">
                </app-secondary-list-item>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="instrument-container">
          <div i18n class="container-title">Instrument Runs</div>
          <ng-container i18n *ngIf="instrumentRunData.length > 0; else noData">
            <div class="list-container">
              <div class="secondary-item-container" *ngFor="let instrumentRun of instrumentRunData">
                <app-secondary-list-item [item]="instrumentRun" [config]="instrumentConfig" [url]="'/instrument-run'">
                </app-secondary-list-item>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="news-container" *ngIf="hasNewsData">
      <!-- Header Section (Sparkle Icon + Title + Avatars) -->
      <div class="news-header">
        <div class="header-left">
          <span class="sparkle-icon">✨</span>
          <!-- You can replace with an SVG/Image -->
          <span i18n class="header-title">What's new in Nabsys</span>
        </div>
        <!-- Placeholder for the avatars in the top right -->
        <div class="header-avatars">
          <!-- If you have an image for the avatars, place it here -->
          <img src="assets/avatars-placeholder.png" alt="Team" *ngIf="false" />
        </div>
      </div>

      <!-- Scrollable List of Cards -->
      <div class="news-list">
        <div class="news-item-wrapper" *ngFor="let news of newsData">
          <app-news-card [newsItem]="news"></app-news-card>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="loader" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>

<ng-template #noData>
  <div class="empty-state-container">
    <p i18n>No Data Found</p>
  </div>
</ng-template>

<ng-template #noDataHomePage>
  <div class="empty-state-container empty-state-container-homepage">
    <div class="noDataMsg">
      <p>Power up your genome analysis! Upload OhmX data or a reference genome to begin.</p>
      <div class="noDataBtn">
        <app-buttons
          [name]="btnNameOne"
          [buttonType]="btnMatFlat"
          [buttonStyle]="btnStyleFilledSmallForPrimaryBtn"
          (buttonClickEvent)="redirectToInstrumentRun()"
        >
        </app-buttons>
        <app-buttons
          [name]="btnNameTwo"
          [buttonType]="btnMatFlat"
          [buttonStyle]="btnStyleFilledSmallForPrimaryBtn"
          (buttonClickEvent)="redirectToFastaFile()"
        >
        </app-buttons>
      </div>
    </div>
  </div>
</ng-template>
